import OptionToggle from '~/components/OptionToggle.jsx';
import React from 'react';
import {
    FEATURE_PACKAGES,
    FEATURE_SUBSCRIPTIONS,
    useFeatures,
} from '~/lib/Features.js';

const ShowPackageBalanceSettings = ({ settings, setSettings, className }) => {
    const { isEnabled } = useFeatures();

    if (!isEnabled(FEATURE_PACKAGES) && !isEnabled(FEATURE_SUBSCRIPTIONS)) {
        return null;
    }

    return (
        <OptionToggle
            className={className}
            value={settings?.showPackageBalanceEmail}
            onChange={value =>
                setSettings({
                    ...settings,
                    showPackageBalanceEmail: value,
                })
            }
            title="Package/Subscription Balances"
            description="Allow clients to view the balance remaining for any packages or subscriptions based on their email address"
        />
    );
};

export default ShowPackageBalanceSettings;
